import { useEffect, useRef, useState } from "react";

const contactInfo = [
  {
    label: "Company",
    value: "KESTEN d. o. o.",
    icon: "ri-building-2-line",
  },
  {
    label: "Address",
    value: "Dobrec 69",
    icon: "ri-map-pin-2-line",
  },
  {
    label: "City",
    value: "Dobrec",
    icon: "ri-map-2-line",
  },
  {
    label: "Zip Code",
    value: "51415",
    icon: "ri-inbox-archive-line",
  },
  {
    label: "Country",
    value: "Croatia",
    icon: "ri-flag-line",
  },
  {
    label: "Email",
    value: "info@kestendoo.com",
    icon: "ri-mail-line",
  },
  {
    label: "Phone",
    value: "+1 8148842595",
    icon: "ri-phone-line",
  },
];

export default function ContactSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const left = contactInfo.slice(0, 4);
  const right = contactInfo.slice(4);

  return (
    <footer id="contact" className="w-full bg-[#111] py-[100px]" ref={ref}>
      <div className="max-w-[1200px] mx-auto px-10">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-[12px] uppercase tracking-[3px] text-emerald-500 font-semibold">
            Get In Touch
          </span>
          <h2 className="text-[44px] font-bold text-white leading-[1.15] mt-4 mb-4">
            Contact
          </h2>
          <p className="text-[17px] text-white/50 max-w-[480px] mx-auto leading-[1.7]">
            Have a question or want to learn more about our products? Reach out — we&apos;re always happy to hear from you.
          </p>
        </div>

        {/* Info Grid */}
        <div
          className={`grid grid-cols-2 gap-x-20 gap-y-0 transition-all duration-700 delay-150 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {/* Left column */}
          <div className="flex flex-col gap-0 divide-y divide-white/[0.07]">
            {left.map((item) => (
              <div key={item.label} className="flex items-center gap-5 py-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/[0.06] text-emerald-500 flex-shrink-0">
                  <i className={`${item.icon} text-xl`} />
                </div>
                <div>
                  <p className="text-[11px] uppercase tracking-[2px] text-white/35 font-medium mb-1">
                    {item.label}
                  </p>
                  <p className="text-[18px] text-white font-medium">{item.value}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Right column */}
          <div className="flex flex-col gap-0 divide-y divide-white/[0.07]">
            {right.map((item) => (
              <div key={item.label} className="flex items-center gap-5 py-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/[0.06] text-emerald-500 flex-shrink-0">
                  <i className={`${item.icon} text-xl`} />
                </div>
                <div>
                  <p className="text-[11px] uppercase tracking-[2px] text-white/35 font-medium mb-1">
                    {item.label}
                  </p>
                  <p className="text-[18px] text-white font-medium">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div
          className={`mt-14 pt-8 border-t border-white/10 flex items-center justify-between transition-all duration-700 delay-300 ${
            visible ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 flex items-center justify-center">
              <img
                src="https://public.readdy.ai/ai/img_res/f9bdbb95-fa9b-40b0-ac14-058556f0e253.png"
                alt="KESTEN d. o. o."
                className="w-7 h-7 object-contain opacity-80"
              />
            </div>
            <span className="text-white/50 text-[14px] font-medium">KESTEN d. o. o.</span>
          </div>
          <p className="text-[13px] text-white/30">
            &copy; {new Date().getFullYear()} KESTEN d. o. o. All rights reserved.
          </p>
          <p className="text-[13px] text-white/30">iOS Development Experts</p>
        </div>
      </div>
    </footer>
  );
}
